import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewParteNovedad = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'parte_novedad',
        name: 'Parte Corral',
        component: ViewParteNovedad,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
